import { reviews } from '@/mocks/home';
import SectionHeading from './SectionHeading';
import ScrollReveal from './ScrollReveal';

export default function Reviews() {
  return (
    <section className="bg-warm-50/60">
      <div className="section-padding">
        <SectionHeading
          index="06"
          eyebrow="用户评价"
          title="500万用户的共同选择"
          subtitle="优质阅读体验与丰富资源，赢得数百万用户的信赖与好评。"
        />

        <div className="grid md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {reviews.map((review, i) => (
            <ScrollReveal key={review.name} delay={i * 80}>
              <div className="group relative h-full bg-white rounded-lg border-2 border-gray-900 p-8 flex flex-col shadow-[4px_4px_0_0_#ff9db8] hover:shadow-[4px_4px_0_0_#1a1a1a] hover:-translate-y-1.5 transition-all duration-300 overflow-hidden">
                {/* 对话气泡引号 */}
                <span className="absolute top-4 right-4 w-9 h-9 rounded-lg border-2 border-gray-900 bg-pink-50 flex items-center justify-center">
                  <i className="ri-double-quotes-l text-lg text-pink-500" />
                </span>

                <div className="flex items-center gap-1 mb-5">
                  {Array.from({ length: review.rating }).map((_, j) => (
                    <i key={j} className="ri-star-fill text-sm text-amber-400" />
                  ))}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed flex-1">{review.content}</p>
                <div className="mt-7 pt-6 border-t-2 border-gray-100 flex items-center gap-4">
                  <div className="w-11 h-11 rounded-lg overflow-hidden border-2 border-gray-900 bg-pink-50 flex-shrink-0">
                    <img
                      src={review.avatar}
                      alt={review.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-bold text-gray-900">{review.name}</p>
                    <p className="text-xs text-gray-400 mt-0.5">{review.role}</p>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}